/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AbsoluteNumberField, MoneyField, ZielstundenField } from '../Fields';
import { Currency, Money } from '@/domain/controlling/entities';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { getAbweichung } from './getAbweichung';

export function Abweichung({
  baseValue = 0,
  comparisonValue,
  type,
  unit,
  tooltipMessage,
}: {
  baseValue?: number;
  comparisonValue: number;
  type: 'absatz' | 'umsatz' | 'stunden';
  unit: string;
  tooltipMessage: string;
}) {
  const { abweichung, isNegative, prozentualeAbweichung } = getAbweichung({
    baseValue,
    comparisonValue,
  });

  const colorWithSelektor =
    prozentualeAbweichung <= 5
      ? '[&>div]:text-primary-green-G500'
      : prozentualeAbweichung > 5 && prozentualeAbweichung <= 10
      ? '[&>div]:text-primary-orange-O500'
      : '[&>div]:text-primary-red-R500';

  const color =
    prozentualeAbweichung <= 5
      ? 'text-primary-green-G500'
      : prozentualeAbweichung > 5 && prozentualeAbweichung <= 10
      ? 'text-primary-orange-O500'
      : 'text-primary-red-R500';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipContent>{tooltipMessage}</TooltipContent>
        <TooltipTrigger>
          <div className="flex flex-row gap-1 items-center font-semibold">
            <FontAwesomeIcon
              icon={
                prozentualeAbweichung === 0 && prozentualeAbweichung <= 5
                  ? faCheck
                  : isNegative
                  ? faCaretDown
                  : faCaretUp
              }
              className={color}
            />
            {type === 'absatz' ? (
              <AbsoluteNumberField
                value={abweichung}
                unit={unit}
                className={colorWithSelektor}
              />
            ) : type === 'umsatz' ? (
              <MoneyField
                value={
                  new Money({ amount: abweichung, currency: Currency.EUR })
                }
                unit={unit}
                className={colorWithSelektor}
              />
            ) : (
              <ZielstundenField
                value={abweichung}
                className={colorWithSelektor}
              />
            )}
          </div>
        </TooltipTrigger>
      </Tooltip>
    </TooltipProvider>
  );
}
